import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';
import {Response} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ProfileService {

    constructor(private http: HttpClient) {}

    get(){
        let requestUrl = environment.apiUrl + 'profile/get';
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    save(profile){
        let requestUrl = environment.apiUrl + 'profile/update';
        return this.http.post(requestUrl, profile).map( (res: any) => {
            return res;
        });
    }

    confirmIdentity(data){
        return this.http.post(environment.apiUrl + 'profile/confirmIdentity', data).map(function(res: any){
            return res;
        });
    }
}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/profile.service.ts